<main class="dashboard-container">
  <div class="tabs-container">
    <div class="tabs-nav">
      <button type="button" class="tab-link" [class.active]="activeTab() === 'models'" (click)="selectTab('models')">
        Modèle de données
      </button>
      <button type="button" class="tab-link" [class.active]="activeTab() === 'diagrams'" (click)="selectTab('diagrams')">
        Diagramme de séquence
      </button>
    </div>

    @if (activeTab() === 'models') {
      <div class="tab-content">
        <div class="content-wrapper">
          <div class="table-card glassmorphism">
            <table>
              <thead>
              <tr>
                <th>Nom du modèle</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
                @for (model of databaseModels(); track model.id) {
                  <tr>
                    <td data-label="Nom" class="model-name">{{ model.title }}</td>
                    <td data-label="Actions" class="actions-cell">
                      <button type="button" class="button-component" (click)="getDatabaseModelById(model.id)">
                        <span [innerHTML]="svgView | safeHtml"></span>
                        <span>Afficher</span>
                      </button>
                      <button type="button" class="button-component warning" (click)="deleteDatabaseModel(model.id)">
                        <span [innerHTML]="svgDelete | safeHtml"></span>
                        <span>Supprimer</span>
                      </button>
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="2" class="empty-state">
                      <p>Aucun modèle de données disponible.</p>
                      <button type="button" class="button-component" (click)="navigateToCreateModel()">
                        <span [innerHTML]="svgCreate | safeHtml"></span>
                        <span>Créer mon premier modèle</span>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }

    @if (activeTab() === 'diagrams') {
      <div class="tab-content">
        <div class="content-wrapper">
          <div class="table-card glassmorphism">
            <table>
              <thead>
              <tr>
                <th>Nom du diagramme</th>
                <th>Actions</th>
              </tr>
              </thead>
              <tbody>
                @for (diagram of sequenceDiagrams(); track diagram.id) {
                  <tr>
                    <td data-label="Nom" class="model-name">{{ diagram.sequenceDiagramTitle }}</td>
                    <td data-label="Actions" class="actions-cell">
                      <button type="button" class="button-component" (click)="getDiagramById(diagram.id)">
                        <span [innerHTML]="svgView | safeHtml"></span>
                        <span>Afficher</span>
                      </button>
                      <button type="button" class="button-component warning" (click)="deleteDiagram(diagram.id)">
                        <span [innerHTML]="svgDelete | safeHtml"></span>
                        <span>Supprimer</span>
                      </button>
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="2" class="empty-state">
                      <p>Aucun diagramme de séquence disponible.</p>
                      <button type="button" class="button-component" (click)="navigateToCreateDiagram()">
                        <span [innerHTML]="svgCreate | safeHtml"></span>
                        <span>Créer mon premier diagramme</span>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  </div>
</main>
